import Icon from "@/components/UI/Icon/Icon"
import styles from './DarkModeToggle.module.scss'
import { useDarkMode } from "@/components/ThemeProvider/ThemeProvider"

type Props = {}

const DarkModeToggle: React.FC<Props> = () => {

  const [isDarkMode, setDarkMode] = useDarkMode()

  const handleToggle = () => {
    setDarkMode(!isDarkMode)
  }

  return (
    <a onClick={handleToggle} className={styles.toggle}><Icon icon="moon" /></a>
  )
}

export default DarkModeToggle